import React, { useState, useEffect } from 'react';
import '../css/DatasetList.css';
import TopHeader from './side/TopHeader';
import Sidebar from './side/Sidebar';
import ConfirmPopup from './side/ConfirmPopup';
import ErrorPopup from './side/ErrorPopup';
import Pagination from './side/Pagination';
import axios from 'axios';
import { SERVER_URL } from '../../config/config';
import { useNavigate } from 'react-router-dom';

const DatasetList = () => {
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 5;
  const navigate = useNavigate();

  useEffect(() => {
    fetchDatasets();
  }, []);

  const fetchDatasets = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/dataset/all`);
      console.log("AI 데이터셋 목록 : " , response.data.data);
      if (response.data.result_code !== 201) {
        throw new Error('Failed to fetch datasets');
      }
      setDatasets(response.data.data || []);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleDelete = async (datasetId) => {
    try {
      console.log("datasetId : " , datasetId);
      const response = await axios.delete(`${SERVER_URL}/admin/dataset`, {
        params: {
          admin_id: localStorage.getItem('adminId'),
          dataset_id: datasetId
        }
      });
      if (response.data.result_code !== 201) {
        throw new Error('Failed to delete dataset');
      }
      setShowConfirmPopup(false);
      setSuccessMessage(`${selectedDataset.name}을(를) 성공적으로 삭제하였습니다.`);
      setShowSuccessPopup(true);
      setSelectedDataset(null);
      fetchDatasets();
      
      // 2초 후 성공 메시지 팝업 닫기
      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleDeleteClick = (datasetId, datasetName) => {
    setSelectedDataset({ id: datasetId, name: datasetName });
    setShowConfirmPopup(true);
  };

  const handleCancelDelete = () => {
    setShowConfirmPopup(false);
    setSelectedDataset(null);
  };

  const getCurrentPageItems = (items) => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return items.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const totalPages = Math.ceil(datasets.length / ITEMS_PER_PAGE);

  const handleDownload = async (datasetId, datasetName) => {
    try {
      const response = await axios.get(
        `${SERVER_URL}/admin/ai/dataset/download`,
        {
          params: {
            dataset_id: datasetId,
            admin_id: localStorage.getItem('adminId')
          },
          responseType: 'blob'
        }
      );
      
      // 다운로드 트리거
      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = datasetName; // 파일명 지정
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (err) {
      alert('다운로드 중 오류 발생: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="dataset-management">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="loading">데이터셋을 불러오는 중...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-management">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="error">Error: {error}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>AI 데이터셋 목록</h1>
            <button className="button" style={{ padding: '10px 10px' }} onClick={() => navigate('/ai/dataset/add')}>
              새 데이터셋 추가
            </button>
          </div>
          <div className="table-container">
            <div className="header-row" id="datalist-header-row">
              <span style={{ width: '15%' }}>업로드 날짜</span>
              <span style={{ width: '25%' }}>데이터셋 이름</span>
              <span style={{ width: '15%' }}>파일 크기</span>
              <span style={{ width: '20%' }}>업로드한 사람</span>
              <span style={{ width: '25%', marginRight: '10px' }}>옵션</span>
            </div>
            <div className="data-entries">
              {getCurrentPageItems(datasets).map((dataset) => (
                <div key={dataset.datasetId} className="table-row" id="datalist-table-row">
                  <span className="cell" style={{ width: '15%' }}>{new Date(dataset.uploadDate).toLocaleDateString('ko-KR')}</span>
                  <span className="cell" style={{ width: '25%' , justifyContent: 'left' }}>{dataset.name}</span>
                  <span className="cell" style={{ width: '15%' }}>{dataset.size.toFixed(2)} GB</span>
                  <span className="cell" style={{ width: '20%' }}>{dataset.uploaderName || '알 수 없음'}</span>
                  <span className="cell" style={{ width: '12.5%' }}>
                    <button className="button" style={{ fontSize: '14px'}} onClick={() => handleDownload(dataset.datasetId, dataset.name)}>다운로드</button>
                  </span>
                  <span className="cell" style={{ width: '12.5%' }}>
                    <button className="delete-button" onClick={() => handleDeleteClick(dataset.datasetId, dataset.name)}>삭제</button>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          {showConfirmPopup && (
            <ConfirmPopup
              message={`${selectedDataset.name}을(를) 삭제하시겠습니까?`}
              onConfirm={() => handleDelete(selectedDataset.id)}
              onCancel={handleCancelDelete}
            />
          )}
          {showSuccessPopup && (
            <ErrorPopup
              message={successMessage}
              onClose={() => setShowSuccessPopup(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DatasetList; 